<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <div>
        <img src="@/assets/images/logo.png" style="width: 320px;"/>
      </div>
      <Tabs>
        <TabPane v-if="showNameAndPassword" label="账户登录">
          <Card icon="log-in" title="用户登录" :bordered="false">
            <div class="form-con">
              <login-form @on-success-valid="handleSubmit"></login-form>
              <p class="login-tip">输入用户名和密码</p>
            </div>
          </Card>
        </TabPane>
        <TabPane label="二维码登录" style="text-align: center;">
          <div id="wechatLoginQRCode">二维码位置</div>
        </TabPane>
        <TabPane label="短信登录">
          <Card icon="log-in" title="短信登录" :bordered="false">
            <div class="form-con">
              <sms-login-form @on-success-valid="smshandleSubmit"></sms-login-form>
            </div>
          </Card>
        </TabPane>
      </Tabs>
      <div style="text-align: center; color: #e8e8e8;"><a href="http://beian.miit.gov.cn" rel="noffolw" target="_blank">粤ICP备18126465号</a></div>
    </div>

  </div>
</template>

<script>
  import store from '@/store'
  import LoginForm from '_c/login-form'
  import SmsLoginForm from '_c/sms-login-form'
  import {mapActions} from 'vuex'
  import {setToken, getToken, canTurnTo} from '@/libs/util'

  export default {
    components: {
      LoginForm,
      SmsLoginForm
    },
    data() {
      return {
        showNameAndPassword:false,
        wechatLoginQRCodeObj: null
      }
    },
    methods: {
      ...mapActions([
        'getUserInfo',
        'AccountServ_LoginByNameAndPassword',
        'AccountServ_GetSelfInfo',
        'AccountServ_LoginByWebApp',
        'ClientAccountServ_RegisterAndLoginByWebApp'
      ]),
      smshandleSubmit({mobilePhoneNum, mobileVerifyCode}){
        let loginForm = {
          mobilePhoneNum: mobilePhoneNum,
          mobileVerifyCode: mobileVerifyCode
        }
        // 短信登录
        store.dispatch('AccountServ_LoginByMobilePhoneNum', {
          params: loginForm,
          urlparams: null
        }).then(() => {
          //登录成功,获取个人账户信息
          store.dispatch('AccountServ_GetSelfInfo', {
            params: null,
            urlparams: null
          }).then(() => {
            let selfInfo = store.getters.get_Account_GetSelfInfoResult
            if (selfInfo.roles.length === 0) {
              this.$Message.error('无登录权限')
            } else if (selfInfo.roles.length === 1 && selfInfo.roles[0].name === 'client') {
              this.$Message.error('无登录权限')
            } else {
              this.$Message.success('登录成功')
              setToken('adminUser')
              this.$router.push({
                name: this.$config.homeName
              })
            }
          }).catch(err1 => {
            this.$Message.error('获取个人账号信息失败')
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      handleSubmit({userName, password, webVerifyCode}) {

        let loginForm = {
          name: userName,
          password: password,
          webVerifyCode: webVerifyCode
        }

        this.AccountServ_LoginByNameAndPassword(
          {
            params: loginForm,
            extfunc: (commit, params, urlparams) => {
              console.log('AccountServ_LoginByNameAndPassword ok')
              setToken('adminUser')
              this.$router.push({
                name: this.$config.homeName
              })
            }

          }).then(res => {

        }).catch(err => {
          this.$Message.error(err)
        })

      },
      updateQRCode(){
        let enRedirectUri = encodeURIComponent('https://jcerp.jianchengjt.com/login')
        let appId = 'wx3249e8a25955e037'
        let containerId = 'wechatLoginQRCode'
        this.wechatLoginQRCodeObj = WxLogin({
          self_redirect: false,
          id: containerId,
          appid: appId,
          scope: 'snsapi_login',
          redirect_uri: enRedirectUri,
          state: '',
          style: 'white',
          href: ''
        })
      }
    },
    created(){
      if(process.env.NODE_ENV==='development'){
        this.showNameAndPassword = true
      }else{
        this.showNameAndPassword = false
      }
    },
    mounted() {
      this.$nextTick(() => {
        let code = this.$route.query.code
        let state = this.$route.query.state
        this.$route.query.code = null
        this.$route.query.state = null
        if (code) {
          // 扫码后生成code
          console.log('扫码操作')
          store.dispatch('AccountServ_LoginByWebApp', {
            params: {wechatWebAppAppId: 'wx3249e8a25955e037', wechatCode: code, state: state},
            urlparams: null
          }).then(() => {
            //扫码登录成功,获取个人账户信息
            store.dispatch('AccountServ_GetSelfInfo', {
              params: null,
              urlparams: null
            }).then(() => {
              let selfInfo = store.getters.get_Account_GetSelfInfoResult
              if (selfInfo.roles.length === 0) {
                this.$Message.error('无登录权限')
                this.updateQRCode()
              } else if (selfInfo.roles.length === 1 && selfInfo.roles[0].name === 'client') {
                this.$Message.error('无登录权限')
                this.updateQRCode()
              } else {
                this.$Message.success('登录成功')
                setToken('adminUser')
                this.$router.push({
                  name: this.$config.homeName
                })
              }
            }).catch(err => {
              this.$Message.error('获取个人账号信息失败')
              this.updateQRCode()
            })
          }).catch(err => {
            //扫码登录失败，尝试注册记录扫码用户信息
            let rsp = store.getters.get_Account_LoginByWebAppResult
            if (rsp.code === 301) {
              store.dispatch('ClientAccountServ_RegisterAndLoginByWebApp', {
                params: {
                  wechatWebAppAppId: 'wx3249e8a25955e037',
                  wechatToken: rsp.data.accessToken,
                  wechatWebAppOpenId: rsp.data.openId,
                  wechatUnionId: rsp.data.unionId
                },
                urlparams: null
              }).then(() => {
                //注册登录成功，获取个人账户信息
                store.dispatch('AccountServ_GetSelfInfo', {
                  params: null,
                  urlparams: null
                }).then(() => {
                  let selfInfo = store.getters.get_Account_GetSelfInfoResult
                  if (selfInfo.roles.length === 0) {
                    this.$Message.error('无登录权限')
                    this.updateQRCode()
                  } else if (selfInfo.roles.length === 1 && selfInfo.roles[0].name === 'client') {
                    this.$Message.error('无登录权限')
                    this.updateQRCode()
                  } else {
                    this.$Message.success('登录成功')
                    setToken('adminUser')
                    this.$router.push({
                      name: this.$config.homeName
                    })
                  }
                }).catch(err1 => {
                  this.$Message.error('获取个人账号信息失败')
                  this.updateQRCode()
                })
              }).catch(err2 => {
                this.$Message.error(err2)
                this.updateQRCode()
              })
            } else {
              // 其他失败情况
              this.$Message.error(err)
              console.log(err)
              this.updateQRCode()
            }
          })
        } else {
          //  未扫码
          console.log('未扫码')
          this.updateQRCode()
        }
      })
    }
  }
</script>

<style scoped>
</style>
